import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import ExtractPDFPagesImageListScreen from "./ExtractPDFPagesImageListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function ExtractPDFPagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Extract PDF Pages Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/extract_pdf_pages", title: "Extract Pages From PDF" },
    data2: { link: "/extract_pdf_pages", title: "PDF Page Extractor" },
    data3: {
      link: "/extract_pdf_pages",
      title: "Extract PDF Pages Seperately",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Extract PDF pages online easily. Select and save specific pages from PDFs quickly with our fast, secure, and easy PDF page extractor tool."
      ></meta>
      <meta
        name="keywords"
        content="extract PDF pages, PDF page extractor, extract pages from PDF, select PDF pages, PDF editor online, PDF page tool, online PDF extractor, save PDF pages, PDF management tool, PDF document editor, extract PDF online, PDF page selection, extract specific PDF pages, PDF page saver, PDF editing tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ExtractPDFPagesImageListScreen
          title={title}
        ></ExtractPDFPagesImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Extract PDF Pages website provides a fast, secure, and flexible solution to extract pages from PDF files both offline and online, making document management simple and efficient. Designed for students, professionals, and businesses, this powerful PDF page extractor allows you to select and extract specific pages from large PDF documents without affecting the original file. With offline functionality, all PDF page extraction is processed directly on your device, ensuring complete privacy and data security without uploading files to external servers. When internet access is available, users can also extract PDF pages online using a smooth, browser-based interface for instant results. Whether you need to extract PDF pages separately, split a PDF into individual pages, or save selected pages as a new document, this tool delivers accurate output while preserving original layout and quality. The platform supports extract PDF pages online free, allowing users to perform quick extractions without complex setup or subscriptions. Using advanced processing technology, the tool maintains text clarity, images, and formatting during extraction, ensuring professional-quality results. Compatible with desktop and mobile devices, this website helps users extract pages from PDF files efficiently for assignments, reports, legal documents, and presentations. If you are searching for the best PDF page extractor, extract PDF pages online free, extract PDF pages online, or a reliable way to extract PDF pages separately both offline and online, this platform offers a complete, user-friendly, and privacy-first solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Extract",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Extract PDF Pages"
            why_use={[
              {
                title: "Work with Only Required PDF Pages",
                description:
                  "Large PDF files often contain unnecessary content. Using a PDF page extractor helps you extract PDF pages and focus only on the information you need.",
              },
              {
                title: "Reduce PDF File Size Easily",
                description:
                  "By removing unwanted pages, you can significantly reduce document size. Tools that extract PDF pages online create smaller, optimized PDFs for easy sharing.",
              },
              {
                title: "Extract PDF Pages Separately",
                description:
                  "When individual pages are needed as standalone files, a reliable tool lets you extract PDF pages separately without affecting the original document.",
              },
              {
                title: "Easy Sharing and Emailing",
                description:
                  "Sharing selected pages is faster than sending entire documents. Using extract PDF pages online free tools makes emailing and messaging simple.",
              },
              {
                title: "Improve Document Organization",
                description:
                  "Extracting pages helps organize files more efficiently. A PDF page extractor makes it easy to split, rearrange, or archive important pages.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals often need to extract PDF pages online for assignments, reports, contracts, and presentations quickly and accurately.",
              },
              {
                title: "Preserve Original Quality and Layout",
                description:
                  "Modern extraction tools maintain text clarity, images, and formatting, ensuring extracted PDF pages remain professional and print-ready.",
              },
              {
                title: "Save Time in Document Workflows",
                description:
                  "Instead of recreating documents, a PDF page extractor allows instant extraction, speeding up everyday PDF management tasks.",
              },
              {
                title: "Work Offline or Online Anytime",
                description:
                  "Offline and online tools allow you to extract PDF pages securely without internet access or extract PDF pages online free when connected.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I extract pages from a PDF for free?",
                description:
                  "You can use the Extract PDF Pages tool on ShivaPDF.com to select the pages you need from a PDF document and create a new PDF containing only those pages. This is useful for saving specific chapters, forms, reports, or individual pages.",
              },
              {
                title: "Can I extract PDF pages without uploading my file?",
                description:
                  "If the ShivaPDF Extract PDF Pages tool processes files entirely in your browser, you can extract pages without uploading your document to a remote server. This can help protect the privacy of personal and confidential documents.",
              },
              {
                title: "Can I extract PDF pages offline?",
                description:
                  "You can extract PDF pages offline only when the tool and its required resources are available on your device. If the tool requires an internet connection to load or access certain features, you will need to connect before using it.",
              },
              {
                title: "Is it safe to extract pages from a PDF online?",
                description:
                  "The safety of your documents depends on how the PDF tool processes files. A tool that performs extraction locally in your browser can help reduce privacy risks because the document does not need to be sent to a remote server. Check the tool's processing method before using confidential files.",
              },
              {
                title: "Can I extract specific pages from a PDF?",
                description:
                  "Yes, you can select the specific PDF pages you want to keep and extract them into a separate document. This is helpful when you need only certain pages from a long report, ebook, invoice, or contract.",
              },
              {
                title: "Can I extract multiple pages from a PDF at once?",
                description:
                  "Yes, you can extract multiple selected pages in one operation when supported by the tool. Choose the pages you need and generate a new PDF containing those pages instead of processing each page separately.",
              },
              {
                title: "Can I extract non-consecutive pages from a PDF?",
                description:
                  "Yes, if page selection supports individual pages or page ranges, you can extract non-consecutive pages such as pages 1, 4, and 9 into a new PDF. This helps you collect relevant information without keeping the entire document.",
              },
              {
                title: "Can I extract a range of pages from a PDF?",
                description:
                  "Yes, you can extract a continuous range of pages when range selection is supported. For example, selecting pages 5 through 10 creates a smaller PDF containing the requested section of the original document.",
              },
              {
                title: "Can I extract only one page from a PDF?",
                description:
                  "Yes, select the page you want to keep and extract it as a separate, single-page PDF. This is useful for saving an individual receipt, certificate, application form, or page from a larger document.",
              },
              {
                title: "Will extracting PDF pages change the original file?",
                description:
                  "Extracting pages creates a separate PDF containing the selected pages. The original document should remain unchanged, so you can keep the full version and use the extracted file separately.",
              },
              {
                title: "Will extracted PDF pages keep their original formatting?",
                description:
                  "Extracting pages generally preserves the selected pages' original appearance, including text, images, layout, and page dimensions. The result may depend on the PDF structure and the extraction method used.",
              },
              {
                title: "Can I extract pages from a scanned PDF?",
                description:
                  "You can generally extract pages from a scanned PDF if the document is supported by the tool. Since scanned pages are often stored as images, extracting them does not necessarily make their text searchable or editable.",
              },
              {
                title: "Can I extract pages from a password-protected PDF?",
                description:
                  "Password-protected PDFs may require the correct password before pages can be extracted. Whether protected documents are supported depends on the tool and the document's security permissions.",
              },
              {
                title: "Can I extract PDF pages on my phone?",
                description:
                  "You can use ShivaPDF.com on a supported mobile browser to extract PDF pages from your iPhone, Android phone, or tablet, provided the tool supports your device and browser.",
              },
              {
                title: "Can I extract pages from a large PDF file?",
                description:
                  "Large PDF files may require more memory and processing time, especially when they contain high-resolution scans or many pages. The ability to process a large document depends on the tool's limits and your device's available resources.",
              },
              {
                title: "Can I choose the order of extracted PDF pages?",
                description:
                  "The order of the extracted pages depends on the selection and ordering features supported by the tool. Review the selected pages before creating the new PDF to ensure the resulting document has the order you need.",
              },
              {
                title: "Does extracting PDF pages reduce file size?",
                description:
                  "Extracting only the pages you need can reduce the size of the resulting PDF because it excludes the other pages. The amount of reduction depends on the content and size of the selected pages.",
              },
              {
                title: "Do I need to install software to extract PDF pages?",
                description:
                  "No separate desktop application is needed when using ShivaPDF's browser-based Extract PDF Pages tool. Open the website in a supported browser and follow the available steps to create a PDF containing your selected pages.",
              },
              {
                title: "Can I extract pages from a PDF without creating an account?",
                description:
                  "You can use the tool without registering if ShivaPDF does not require an account for the feature. Check the extraction page for any usage restrictions or requirements.",
              },
              {
                title: "How do I save the extracted PDF pages?",
                description:
                  "After selecting the required pages and completing the extraction, use the download option to save the new PDF to your device. Open the downloaded file to verify that the correct pages are included.",
              },
              {
                title: "Why should I use ShivaPDF to extract PDF pages?",
                description:
                  "ShivaPDF provides browser-based PDF tools that help you manage documents without installing a separate desktop application. Use the Extract PDF Pages tool to create a smaller PDF containing only the pages relevant to your work or personal needs.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ExtractPDFPagesMain;
